import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../../../api/axios";

export function useReturnUnit<T>(opts: {
  managementBase: string;
  invalidateKey: readonly unknown[];
  getUnitId: (item: T) => number | null;
}) {
  const queryClient = useQueryClient();
  const [pending, setPending] = useState<T | null>(null);

  const mutation = useMutation({
    mutationFn: (unitId: number) =>
      api.put(`/${opts.managementBase}/return-unit/${unitId}`),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: opts.invalidateKey });
      setPending(null);
    },
  });

  return {
    pending,
    isPending: mutation.isPending,
    open: (item: T) => setPending(item),
    close: () => setPending(null),
    confirm: () => {
      if (pending == null) return;
      const unitId = opts.getUnitId(pending);
      if (unitId != null) mutation.mutate(unitId);
    },
  };
}
